<template lang="pug">
  SingleLayout(
    :item='true'
  )
    template(
      slot='item'
    )
      AlbumEditor(
        v-if='newAlbum'
        :album='newAlbum'
        :directions='directions'
      )
</template>

<script>
import { mapActions } from "vuex";

import l10n from "@/services/l10n";
import PageLoader from "@/services/pageLoader";
import errorHandler from "@/services/errorHandler";
import AlbumEditor from "@/components/Editor/AlbumEditor";
import singlePage from "@/mixins/pages/single.mixin";

import { CURRENT_YEAR } from "@/constants";

const strategy = async function(route, ctx) {
  try {
    const { directions } = await PageLoader.getDirections();
    const genresIds = directions.reduce((genres, direction) => {
      return [...genres, ...direction.items];
    }, []);

    await PageLoader.getGenres({
      ids: genresIds
    });

    if (route.query.type) {
      ctx.type = route.query.type;
    }

    const isSingles = ctx.type === "singles";
    const title = isSingles ? l10n("NEW_SINGLE") : l10n("NEW_ALBUM");

    ctx.directions = directions;
    ctx.album = {
      title,
      year: CURRENT_YEAR,
      is_single: ctx.type === "singles" ? 1 : 0
    };

    route.meta.title = title;
  } catch (error) {
    errorHandler.add(error);
  }
};

export default {
  name: "AlbumCreate",
  data() {
    return {
      type: "albums",
      album: null,
      newAlbum: null,
      directions: []
    };
  },
  mixins: [singlePage(strategy)],
  components: {
    AlbumEditor
  },
  methods: {
    ...mapActions({
      createAlbum: "albums/create"
    })
  },
  beforeMount() {
    setTimeout(async () => {
      this.newAlbum = await this.createAlbum(this.album);
      this.$router.replace(`/albums/${this.newAlbum.id}/edit`).catch(() => {});
    });
  }
};
</script>
